function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 23,
  fill: "currentColor"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "#FFF",
  d: "M23,22.1153846 L31.4584322,22.1153846 C31.672565,22.1153846 31.8461538,22.3134125 31.8461538,22.5576923 C31.8461538,22.8019721 31.672565,23 31.4584322,23 L23,23 L23,32.3415385 C23,32.5565047 22.8019721,32.7307692 22.5576923,32.7307692 C22.3134125,32.7307692 22.1153846,32.5565047 22.1153846,32.3415385 L22.1153846,23 L13.6569524,23 C13.4428197,23 13.2692308,22.8019721 13.2692308,22.5576923 C13.2692308,22.3134125 13.4428197,22.1153846 13.6569524,22.1153846 L22.1153846,22.1153846 L22.1153846,13.6584615 C22.1153846,13.4434953 22.3134125,13.2692308 22.5576923,13.2692308 C22.8019721,13.2692308 23,13.4434953 23,13.6584615 L23,22.1153846 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 46 46",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/new.1e8f1650.svg";
export { SvgComponent as ReactComponent };